import Vue from "vue";
import VueRouter from "vue-router";
import MainLayout from "@/layouts/MainLayout.vue";

/* User routes */
const Contact = () => import("@/views/Contact.vue");
const Experience = () => import("@/views/Experience.vue");
const Home = () => import("@/views/Home.vue");
const Jobs = () => import("@/views/Jobs.vue");
const JobDetail = () => import("@/views/JobDetail.vue");
const ManageProperties = () => import("@/views/ManageProperties.vue");
const PropertyDetail = () => import("@/views/PropertyDetail.vue");
const Properties = () => import("@/views/Properties.vue");
const RentBuy = () => import("@/views/RentBuy.vue");
const NoticePrivacy = () => import("@/views/NoticePrivacy.vue");
const QR = () => import("@/views/QR.vue");
const Alliances = () => import("@/views/Alliances.vue");
const PublicBlog = () => import("@/views/PublicBlog.vue");
const PublicBlogPost = () => import("@/views/PublicBlogPost.vue");

/* Admin routes */
const AdminLayout = () => import("@/layouts/AdminLayout.vue");
const AdminLogin = () => import("@/views/admin/auth/Login.vue");
const AdminPasswordRecovery = () =>
  import("@/views/admin/auth/PasswordRecovery.vue");
const AdminRegister = () => import("@/views/admin/auth/Register.vue");
const AdminConfirmEmail = () => import("@/views/admin/auth/ConfirmEmail.vue");
const AdminPasswordReset = () => import("@/views/admin/auth/PasswordReset.vue");
const AdminHome = () => import("@/views/admin/Home.vue");
const AdminProperties = () => import("@/views/admin/Properties.vue");
const AdminJobs = () => import("@/views/admin/Jobs.vue");
const AdminCreateJob = () => import("@/views/admin/CreateJob.vue");
const AdminBlog = () => import("@/views/admin/blog/Blog.vue");
const AdminCreateBlog = () => import("@/views/admin/blog/CreateBlog.vue");
const AdminBlogFavorites = () => import("@/views/admin/blog/Favorites.vue");
const AdminUsers = () => import("@/views/admin/users/Users.vue");
const AdminCreateUser = () => import("@/views/admin/users/CreateUser.vue");
const AdminUpdateUser = () => import("@/views/admin/users/UpdateUser.vue");
const AdminMyAccount = () => import("@/views/admin/users/Account.vue");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "main-layout",
    component: MainLayout,
    redirect: { name: "home" },
    children: [
      {
        path: "/",
        name: "home",
        component: Home
      },
      {
        path: "propiedades",
        name: "properties",
        component: Properties
      },
      {
        path: "propiedades/:id",
        name: "property-detail",
        component: PropertyDetail
      },
      {
        path: "qr/:id",
        name: "qr",
        component: QR
      },
      {
        path: "administrar-propiedades",
        name: "manage-properties",
        component: ManageProperties,
        props: route => ({
          section: `#${route.query.s}`
        })
      },
      {
        path: "experiencia",
        name: "experience",
        component: Experience
      },
      {
        path: "bolsa-de-trabajo",
        name: "jobs",
        component: Jobs
      },
      {
        path: "bolsa-de-trabajo/:id",
        name: "job-detail",
        component: JobDetail
      },
      {
        path: "contacto",
        name: "contact",
        component: Contact
      },
      {
        path: "rentar-comprar",
        name: "rent-buy",
        component: RentBuy
      },
      {
        path: "aviso-de-privacidad",
        name: "notice-privacy",
        component: NoticePrivacy
      },
      {
        path: "alliances",
        name: "alliances",
        component: Alliances
      },
      {
        path: "blog",
        name: "public-blog",
        component: PublicBlog
      },
      {
        path: "blog/:id",
        name: "public-blog-post",
        component: PublicBlogPost
      }
    ]
  },
  {
    path: "/admin",
    name: "admin",
    redirect: { name: "admin-home" },
    component: AdminLayout,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: "home",
        name: "admin-home",
        component: AdminHome
      },
      {
        path: "propiedades",
        name: "admin-properties",
        component: AdminProperties
      },
      {
        path: "vacantes",
        name: "admin-jobs",
        component: AdminJobs
      },
      {
        path: "crear-vacante",
        name: "admin-create-job",
        component: AdminCreateJob
      },
      {
        path: "blog",
        name: "admin-blog",
        component: AdminBlog
      },
      {
        path: "entry-blog",
        name: "admin-entry-blog",
        component: AdminCreateBlog
      },
      {
        path: "favoritos-blog",
        name: "admin-blog-favorites",
        component: AdminBlogFavorites
      },
      {
        path: "usuarios",
        name: "admin-users",
        component: AdminUsers
      },
      {
        path: "crear-usuario",
        name: "admin-create-user",
        component: AdminCreateUser
      },
      {
        path: "actualizar-usuario/:id",
        name: "admin-edit-user",
        component: AdminUpdateUser
      },
      {
        path: "micuenta",
        name: "admin-account",
        component: AdminMyAccount
      }
    ]
  },
  {
    path: "/admin/login",
    name: "admin-login",
    component: AdminLogin
  },
  {
    path: "/admin/restaurar",
    name: "admin-password-recovery",
    component: AdminPasswordRecovery
  },
  {
    path: "/recuperar-contrasena/:token",
    name: "admin-password-reset",
    component: AdminPasswordReset
  },
  {
    path: "/registrarse",
    name: "admin-register",
    component: AdminRegister
  },
  {
    path: "/confirmar-email/:token",
    name: "admin-confirm-email",
    component: AdminConfirmEmail
  },
  {
    path: "/admin/*",
    name: "404",
    redirect: { name: "admin-login" }
  },
  {
    path: "*",
    redirect: { name: "home" }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem("token") == null) {
      next({
        name: "admin-login"
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
